import React, { useEffect, useState ,useCallback} from "react";
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getfulFillmentStatus, getSupplierFulFillments, updateFulFillmentStatus, getOrderDetailsFulFillments } from '../service/fulfillmentService';
import FormInstructionBox from '../components/FormInstructionBox';


const FulfillmentOrderSupplier = ({data}) => {
  const [tab, setTab] = useState("ALL"); 
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [warehouses, setWarehouses] = useState(data || []);
  const [warehouseIds, setWarehouseIds] = useState(Array.isArray(warehouses)
  ? warehouses.map(w => w.warehouseId)
  : []);
  
    
        const [detailsLoading, setDetailsLoading] = useState(false);
      const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [orderDetails, setOrderDetails] = useState([]);
  
   const [paginationModel, setPaginationModel] = useState({ 
        page: 0, 
        pageSize: 5 
    });
    const [totalRowCount, setTotalRowCount] = useState(0);

      
const fetchOrders = useCallback(async (page, pageSize) => {
        setLoading(true);
        try {
           const warehouseIdsParam = warehouseIds.join(',');
            // Send pagination and search filter as query parameters
             const response = await getSupplierFulFillments(warehouseIdsParam, page,pageSize)
            
            // The backend returns a PageResponse (content, totalElements, totalPages, etc.)
            const data = response.data;
            console.log("totalelement ", data.totalElements);
            console.log("order details  ", data.content);
            setOrders(data.content);
            setTotalRowCount(data.totalElements); // Crucial for DataGrid total count
            
        } catch (error) {
            console.error("Error fetching subcategories:", error);
        } finally {
            setLoading(false);
        }
    }, []);
  
  

  


  useEffect(() => {
   
    fetchOrders(paginationModel.page, paginationModel.pageSize);
    fetchStatuses();

  }, [warehouses,paginationModel.page, paginationModel.pageSize]);
 
     const fetchStatuses = async () => {
    try {
      const res = await getfulFillmentStatus();
      setStatusOptions(res.data);
    } catch (err) {
      console.error("Error fetching referral statuses", err);
    }
  };
  
  const handleStatusChange = async (fulfillmentOrderId, newStatusId) => {
    try {
      setLoading(true);
     await updateFulFillmentStatus(fulfillmentOrderId,newStatusId);

      // update UI locally
      setOrders((prev) =>
        prev.map((o) =>
          o.fulfillmentOrderId === fulfillmentOrderId
            ? {
                ...o,
                fulfillmentStatusId: newStatusId,
                fulfillmentStatusName: statusMap[newStatusId],
              }
            : o
        )
      );
    } catch (error) {
      console.error("Error updating fulfillment status:", error);
    } finally {
      setLoading(false);
    }
  };


  const statusMap = Object.fromEntries(statusOptions.map((s) => [s.id, s.code]));

  // Filter by current tab
/*  const filteredOrders = orders?.filter(
    (o) => (o) => tab === 'ALL' || o.fulfillmentStatusName?.toUpperCase() === tab
  );*/
  const filteredOrders = orders?.filter(
  (o) => tab === 'ALL' || o.fulfillmentStatusName?.toUpperCase() === tab
);
    
  const fetchOrderDetails = async (fulfillmentOrderId) => {
    setDetailsLoading(true);
    setSelectedOrderId(fulfillmentOrderId);
    try {
      const res = await getOrderDetailsFulFillments(fulfillmentOrderId); // adjust your endpoint
      setOrderDetails(res.data); 
        
    } catch (err) {
      console.error("Error fetching order details:", err);
      setOrderDetails([]);
    } finally {
      setDetailsLoading(false);
    }
  };
  
  const columns = [
    { field: "fulfillmentOrderId", headerName: "Fulfillment ID", width: 150 },
    { field: "customerOrderId", headerName: "Customer Order ID", width: 160 },
      { field: "slotStartTimeString", headerName: "Delivery Start Time", width: 180 },
      { field: "slotEndTimeString", headerName: "Delivery End Time", width: 180 },
    { field: "warehouseName", headerName: "Warehouse", width: 140 },
 /*   {
      field: "estimatedShippingCost",
      headerName: "Est. Shipping Cost",
      width: 160,
      valueFormatter: (params) =>
        params.value ? `$${params.value.toFixed(2)}` : "-",
    },*/
    {
      field: "fulfillmentStatusName",
      headerName: "Status",
      width: 150,
    },
    { field: "createdAt", headerName: "Created Date", flex: 1 },
    {
      field: "updateStatus",
      headerName: "Update Status",
      width: 220,
      renderCell: (params) => {
        const fulfillmentStatusName = params.row.fulfillmentStatusName;
        return (
            <>
        {fulfillmentStatusName !== "PICKED_UP" && ( 

        <FormControl fullWidth size="small">
          <Select
            value={params.row.fulfillmentStatusId || ""}
            onChange={(e) =>
              handleStatusChange(
                params.row.fulfillmentOrderId,
                Number(e.target.value)
              )
            }
          >
            {statusOptions.map((status) => (
              <MenuItem key={status.id} value={status.id}>
                {status.code}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
              )}
         </>      
         );
      
      },
    },
  ];
  
    const detailColumns = [
    { field: "orderItemId", headerName: "ID", width: 90 },
    { field: "productName", headerName: "Product", flex: 1 },
    { field: "productVariantName", headerName: "Variant", flex: 1 },
     { field: "size", headerName: "size", flex: 1 },  
    { field: "quantity", headerName: "Qty", width: 100, align: "center" },
  ];
  
        const fulfillmentInstructions = [
        "Pack the Products and Keep it in the location",
        "Click on the FulFillment orde to see the products list.",
          "Once you are done with the Package, Update the status to Ready for Pickup",
          "If you are delivering the product the Customer then select delivered", 
          "When you are preparing the product, change the status to Processing"
          
    ];

  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        bgcolor: "#f9fafb",
        minHeight: "100vh",
      }}
    >
      <Paper sx={{ width: "100%", maxWidth: 1200, p: 4, borderRadius: 3 }}>
        <Typography variant="h4" textAlign="center" fontWeight="bold" mb={3}>
          Fulfillment Order Manager
        </Typography>

              <FormInstructionBox 
                instructions={fulfillmentInstructions} 
                title="Fulfillment Guidelines" 
            />
        
        {/* Tabs */}
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          centered
          sx={{ mb: 3 }}
        >
          <Tab label="All" value="ALL" />
          <Tab label="Pending" value="PENDING"       
        sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        cursor: "pointer",
        transition: "background 0.3s",
        "&:hover": { backgroundColor: "rgba(0, 128, 0, 0.1)" },
        minHeight: 40, // reduced height for header
      }}/>
          <Tab label="Processing" value="PROCESSING" />
          <Tab label="Ready For Pickup" value="READY_FOR_PICK" />
          <Tab label="Picked Up" value="PICKED_UP" />
        </Tabs>

        {/* Content */}
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Box sx={{ height: 420 }}>
 <DataGrid
    pagination
    paginationMode="server"
    rows={filteredOrders}
    columns={columns}
    rowCount={totalRowCount}
    page={paginationModel.page}
    pageSize={paginationModel.pageSize}
    onPageChange={(newPage) => {
      console.log("Page changed:", newPage);
      setPaginationModel((prev) => ({ ...prev, page: newPage }));
    }}
    onPageSizeChange={(newPageSize) => {
      console.log("Page size changed:", newPageSize);
      setPaginationModel((prev) => ({ ...prev, pageSize: newPageSize, page: 0 }));
    }}
    rowsPerPageOptions={[5, 10, 20]} // ✅ correct prop for v5
    loading={loading}
    getRowId={(row) => row.fulfillmentOrderId}
    disableColumnFilter
    disableColumnSorting
    onRowClick={(params) => fetchOrderDetails(params.row.fulfillmentOrderId )}
  />
              {filteredOrders?.length === 0 && (
                <Typography
                  sx={{
                    textAlign: "center",
                    mt: 3,
                    color: "text.secondary",
                  }}
                >
                  No orders in this status.
                </Typography>
              )}
            </Box>

            <Box display="flex" justifyContent="flex-end" mt={3}>
              <Button
                variant="contained"
                onClick={fetchOrders}
                disabled={loading}
              >
                Refresh
              </Button>
            </Box>
                    <Box>
            
                   {selectedOrderId && (
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Order Details — ID #{selectedOrderId}
          </Typography>
          {detailsLoading ? (
            <CircularProgress />
          ) : orderDetails?.length > 0 ? (
            <DataGrid
              rows={orderDetails}
             getRowId={(row) => row.productVariantId} 
              columns={detailColumns}
              autoHeight
            />
          ) : (
            <Typography color="text.secondary">
              No details available for this order.
            </Typography>
          )}
        </Paper>
      )}
            </Box>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default FulfillmentOrderSupplier;
